import $ from "jquery";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { CommandeActionDocumentsGedDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeActionDocumentsGedDto";
import { CommandeActionDossiersGedDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeActionDossiersGedDto";
import { CommandeTelechargementArchive } from "../../dto/GenApi.iNotPaie.Dto/CommandeTelechargementArchive";
import { DocumentDto } from "../../dto/GenApi.iNotPaie.Dto/DocumentDto";
import { DocumentGedDto } from "../../dto/GenApi.iNotPaie.Dto/DocumentGedDto";
import { DocumentInfoDto } from "../../dto/GenApi.iNotPaie.Dto/DocumentInfoDto";
import { DocumentsArchiveDto } from "../../dto/GenApi.iNotPaie.Dto/DocumentsArchiveDto";
import { DossierGedDto } from "../../dto/GenApi.iNotPaie.Dto/DossierGedDto";
import DocumentGedHelper, { DocumentGedViewModel, DossierGedViewModel } from "../../Helper/DocumentGedHelper";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalAjoutEditDossier from "./ajoutEditDossier/modalAjoutEditDossier";

@Component({
    components: {
        ModalAjoutEditDossier: require("./ajoutEditDossier/modalAjoutEditDossier.vue.html")
    },
    beforeRouteEnter(to, from, next) {
        next(v => {
            const vm = (v as DocumentsComponent);
            vm.fetchData();
        });
    }
})
export default class DocumentsComponent extends Vue {
    public dataReady = false;
    public isPreviewReady = true;
    public currentCode?: string = "";
    public modalAjoutEditDossier?: ModalAjoutEditDossier = undefined
    public currentDocument?: DocumentGedDto = undefined;
    public dossierRacine?: DossierGedViewModel = undefined;

    public nombreDocumentsSelectionnes = 0;
    public nombreDossiersSelectionnes = 0;

    public currentData?: Blob = undefined;
    public currentDataUrl?: string = undefined;
    public canPreview = false;

    public updateCurrentData(): void {
        this.isPreviewReady = false;
        this.currentDataUrl = "";

        if (this.currentDocument == undefined || this.currentDocument.Code == undefined) {
            this.isPreviewReady = true;
        } else {
            ServicesFactoryInstance.GedService.getDocument(this.currentDocument.Code, data => {
                this.currentData = data;
                this.currentDataUrl = URL.createObjectURL(this.currentData);
                this.isPreviewReady = true;
                this.$forceUpdate();
            }, () => {
                this.isPreviewReady = true;
                this.canPreview = false;
            });
        }
    }

    /**
     * Chargement de la page
     * @param dossier est vide au chargement de la page, et a une valeur si on vient d'un ajout / suppression
     */
    public fetchData(dossier?: DossierGedViewModel): void {
        if (dossier === undefined || this.dossierRacine === undefined || dossier.CheminLogique === this.dossierRacine.CheminLogique) {
            this.loadData();
        } else {
            this.setLoadingDossier(dossier);
            this.loadDossierData(dossier);
        }
    }

    /**
     * Chargement du dossier racine de la société
     * @returns
     */
    public loadData(): void {
        // Reset des données
        this.dataReady = false;

        // Reset de la previsualisation
        this.resetCurrentData();
        this.resetNbElementsSelectionnes();

        // Récupération des dossiers de base liés à la société
        ServicesFactoryInstance.GedService.getDossierRacine(data => {
            // Récupération et mise à jour du dossier qui était ouvert
            data = DocumentGedHelper.sortArborescence(data);
            this.dossierRacine = DocumentGedHelper.mapDossierToViewModel(data);
            this.dataReady = true;

            // Update de la partie prévisualisation
            this.updateCurrentData();
            this.$forceUpdate();
        });
    }

    public ajouterDossier(dossier: DossierGedViewModel): void {
        if (this.modalAjoutEditDossier == undefined) {
            this.modalAjoutEditDossier = this.$refs.modalAjoutEditDossier as ModalAjoutEditDossier;
        }
        if (this.modalAjoutEditDossier != undefined) {
            this.modalAjoutEditDossier.init(dossier, false);
        }
        $("#modalAjoutEditDossier").modal("show");
    }

    public ajouterDocument(dossier: DossierGedViewModel): void {
        if (this.modalAjoutEditDossier == undefined) {
            this.modalAjoutEditDossier = this.$refs.modalAjoutEditDossier as ModalAjoutEditDossier;
        }
        if (this.modalAjoutEditDossier != undefined) {
            this.modalAjoutEditDossier.init(dossier, true);
        }
        $("#modalAjoutEditDossier").modal("show");
    }

    /**
     * Téléchargement des documents / dossiers sélectionnés
     * @returns
     */
    public telechargerSelection(): void {
        if (this.dossierRacine === undefined)
            return;

        const listeDocumentsSelectionnes = this.getListeDocumentsSelectionnesCascade(this.dossierRacine);
        const listeDossiersSelectionnes = this.getListeDossiersSelectionnes(this.dossierRacine);

        // Selection uniquement de dossiers
        if (listeDocumentsSelectionnes.length === 0 && listeDossiersSelectionnes.length > 0) {
            this.gererTelechargementDossiers(listeDossiersSelectionnes);
        }
        // Selection uniquement de documents
        else if (listeDocumentsSelectionnes.length > 0 && listeDossiersSelectionnes.length === 0) {
            this.gererTelechargementDocuments(listeDocumentsSelectionnes);
        }
        // Selection de documents ET de dossiers
        else if (listeDocumentsSelectionnes.length > 0 && listeDossiersSelectionnes.length > 0) {
            this.gererTelechargementDocumentsEtDossiers(listeDocumentsSelectionnes, listeDossiersSelectionnes);
        }
    }

    public telechargerDocument(Document: DocumentDto): void {
        NotificationServiceInstance.SendInformation("La récupération du document a commencé.", 2);
        this.dataReady = false;

        ServicesFactoryInstance.GedService.getDocument(Document.Code, (d: Blob) => {
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                if (Document.Nom != undefined) {
                    window.navigator.msSaveOrOpenBlob(d, Document.Nom);
                }
            } else {
                const link = document.createElement("a");
                document.body.appendChild(link);
                link.href = window.URL.createObjectURL(d);
                if (Document.Nom != undefined) {
                    link.download = Document.Nom + "." + Document.Extension;
                }
                link.click();
            }
            this.dataReady = true;
        }, () => { this.dataReady = true; });
    }

    /**
     * Cette fonction permet de former une liste de 'DocumentInfoDto' à partir d'une liste de 'DocumentDto'.
     * Cela permet d'embarquer uniquement les informations nécessaires vers le backend.
     * @param {DocumentDto[]} Documents
     * @returns {DocumentDto}
     */
    public getListeDocumentsInfos(Documents: DocumentDto[]): DocumentInfoDto[] {
        let infos: DocumentInfoDto[] = [];

        Documents.forEach(d => infos.push({
            Code: d.Code,
            Nom: d.Nom,
            Extension: d.Extension
        }));

        return infos;
    }

    /**
     * Permet de convertir la string résultante de 'ServicesFactoryInstance.GedService.getArchive' en blob afin qu'elle puisse être téléchargée
     * sous forme de réelle archive .zip.
     * @param {string} archive
     * @returns {Blob}
     */
    public convertArchiveStrToBlob(archive: string): Blob {
        const byteCharacters = atob(archive);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray]);
    }

    /**
     * Cette fonction permet de mettre en forme la liste des documents ayant provoqué une erreur, récupérée en paramètre. Cela permet de n'envoyer qu'un seul
     * message contenant toutes les informations, plutôt qu'un message par document.
     * @param {string[]} erreurs
     */
    public sendFusedErrorsWarning(erreurs: string[]): void {
        let message = "";

        if (erreurs.length === 1) {
            message = "Le document suivant n'a pas pu être récupéré. Il est possible qu'il n'existe plus :<br>";
        } else {
            message = "Les documents suivants n'ont pas pu être récupérés. Il est possible qu'ils n'existent plus :<br>";
        }

        erreurs.forEach(e => {
            message += "<br><strong>-</strong> " + e;
        });

        NotificationServiceInstance.SendWarning(message, 8);
    }

    /**
     * Ouvre le document sélectionné dans la prévisualisation
     * @param document
     */
    public selectDocument(document: DocumentGedDto): void {
        this.currentData = undefined;

        if (document.Extension != undefined && document.Extension.toLowerCase() == "pdf") {
            this.currentDocument = document;
            this.canPreview = true;
        } else {
            this.currentDocument = undefined;
            this.canPreview = false;
        }
        this.updateCurrentData();
        this.currentCode = document.Code;
        this.$forceUpdate();
    }

    public supprimerSelection(): void {
        if (this.dossierRacine === undefined)
            return;

        // Dossiers
        let commandeDossiers: CommandeActionDossiersGedDto = { listeCheminsLogiquesDossiers: this.getListeDossiersSelectionnes(this.dossierRacine) };

        // Documents
        let commandeDocuments: CommandeActionDocumentsGedDto = { listeCodesDocuments: this.getListeDocumentsASupprimer(this.dossierRacine) };

        // Si rien n'a été sélectionner, annuler
        if (commandeDocuments.listeCodesDocuments?.length === 0 && commandeDossiers.listeCheminsLogiquesDossiers?.length === 0) {
            return;
        }

        let message = "Souhaitez-vous réellement supprimer les éléments sélectionnés";
        if (commandeDossiers.listeCheminsLogiquesDossiers !== undefined && commandeDossiers.listeCheminsLogiquesDossiers?.length > 0) {
            message += ` et leur contenu`;
        }
        message += " ?";

        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: message,
            callBackYes: async () => {
                this.dataReady = false;
                let hasDossierSucceeded = false;
                let hasDocumentSucceeded = false;

                // Suppression des dossiers
                if (commandeDossiers.listeCheminsLogiquesDossiers !== undefined && commandeDossiers.listeCheminsLogiquesDossiers?.length > 0) {
                    await ServicesFactoryInstance.GedService.deleteDossiers(commandeDossiers, () => {
                        hasDossierSucceeded = true;
                    });
                } else {
                    // Si aucun dossier n'a été sélectionné, on passe automatiquement en succes
                    hasDossierSucceeded = true;
                }

                // Suppression des documents
                if (commandeDocuments.listeCodesDocuments !== undefined && commandeDocuments.listeCodesDocuments?.length > 0) {
                    await ServicesFactoryInstance.GedService.deleteDocuments(commandeDocuments, () => {
                        hasDocumentSucceeded = true;
                    });
                } else {
                    // Si aucun document n'a été sélectionné, on passe automatiquement en succes
                    hasDocumentSucceeded = true;
                }

                if (hasDocumentSucceeded && hasDossierSucceeded) {
                    // Vide la prévisualisation
                    this.resetCurrentData();
                    this.resetNbElementsSelectionnes();

                    // Enleve les elements sélectionnés de la liste visuelle
                    this.retireElementsSupprimes(this.dossierRacine!);
                    this.dataReady = true;
                } else {
                    // Recharge le dossier racine
                    this.fetchData();
                }
            },
            callBackNo: () => { }
        });

        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public confirmerSuppressionDocument(code: string, dossier: DossierGedViewModel): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous réellement supprimer ce document ?",
            callBackYes: () => {
                this.resetCurrentData();
                this.setLoadingDossier(dossier);
                this.supprimerDocument(code, dossier);
            },
            callBackNo: () => { }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public supprimerDocument(code: string, dossier: DossierGedViewModel): void {

        ServicesFactoryInstance.GedService.deleteDocument({
            Code: code,
            DateDeCreation: new Date(),
            DateDeModification: new Date()
        }, () => {
            this.fetchData(dossier);
        }, () => {
            dossier.isLoading = false;
            dossier.isOpen = false;
            this.$forceUpdate();
        });
    }

    public confirmerSuppressionDossier(cheminLogique: string, dossier: DossierGedViewModel): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous réellement supprimer ce dossier ?",
            callBackYes: () => {
                this.resetCurrentData();
                this.setLoadingDossier(dossier);
                this.supprimerDossier(cheminLogique, dossier);
            },
            callBackNo: () => { }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public supprimerDossier(path: string, dossier: DossierGedViewModel): void {
        ServicesFactoryInstance.GedService.deleteDossier(
            { CheminLogique: path, Documents: [], SousDossier: [] },
            () => {
                this.fetchData(dossier);
            }, () => {
                dossier.isLoading = false;
                dossier.isOpen = false;
                this.dataReady = true;
                this.$forceUpdate();
            });
    }

    public selectionnerDocument(document: DocumentGedViewModel, event?: Event): void {
        event?.stopPropagation();
        // La ligne est un document.
        this.nombreDocumentsSelectionnes += Number(!document.isSelected) - Number(document.isSelected ?? false);
        document.isSelected = !document.isSelected;

        if (!document.isSelected && document.dossierParent != undefined) {
            // En cas de désélection, application de la désélection de la coche à tous les parents de la ligne.
            this.deselectionnerParentCascade(document.dossierParent);
        }
    }

    public selectionnerDossier(dossier: DossierGedViewModel, event?: Event): void {
        if (event != undefined) {
            event.stopPropagation();
            event.preventDefault();
        }

        this.nombreDossiersSelectionnes += Number(!dossier.isSelected) - Number(dossier.isSelected ?? false);
        dossier.isSelected = !dossier.isSelected;

        if (!dossier.isSelected && dossier.dossierParent != undefined) {
            // En cas de désélection, application de la désélection de la coche à tous les parents de la ligne.
            this.deselectionnerParentCascade(dossier.dossierParent);
        }

        this.selectionnerCascade(dossier, dossier.isSelected);

        this.$forceUpdate();
    }

    /**
     * Permet de sélectionner / déselectionner tous les enfants d'un dossier
     * @param dossier
     * @param isSelected false pour déselectionner
     */
    public selectionnerCascade(dossier: DossierGedViewModel, isSelected: boolean): void {
        // La ligne est un dossier.
        this.nombreDossiersSelectionnes += Number(isSelected) - Number(dossier.isSelected ?? false);
        dossier.isSelected = isSelected;

        if (dossier.Documents != undefined && dossier.Documents.length > 0) {
            dossier.Documents.forEach((document: any) => {
                // Application de l'état de la coche à tous les documents liés au dossier.
                this.nombreDocumentsSelectionnes += Number(isSelected) - Number(document.isSelected ?? false);
                document.isSelected = isSelected;
            });
        }

        if (dossier.SousDossier != undefined && dossier.SousDossier.length > 0) {
            dossier.SousDossier.forEach((sousDossier: any) => {
                // Application de l'état de la coche à tous les sous-dossiers liés au dossier.
                this.selectionnerCascade(sousDossier, isSelected);
            });
        }
    }

    public deselectionnerParentCascade(ligne: DossierGedViewModel): void {
        this.nombreDossiersSelectionnes -= Number(ligne.isSelected ?? false);

        ligne.isSelected = false;
        if (ligne.dossierParent != undefined)
            this.deselectionnerParentCascade(ligne.dossierParent);
    }

    /**
     * Permet de set la propriété dossierParent
     * @param dossier
     */
    public affecterParentCascade(dossier: DossierGedViewModel): void {
        if (dossier.Documents != undefined && dossier.Documents.length > 0) {
            dossier.Documents.forEach((document: any) => {
                document.dossierParent = dossier;
            });
        }
        if (dossier.SousDossier != undefined && dossier.SousDossier.length > 0) {
            dossier.SousDossier.forEach((sousDossier: any) => {
                sousDossier.dossierParent = dossier;
                this.affecterParentCascade(sousDossier);
            });
        }
    }

    /**
     * Récupère la liste des documents sélectionnés pour le téléchargement.
     * Ne récupère pas les documents dans des dossiers sélectionnés pour éviter les doublons
     * @param dossier
     * @returns
     */
    public getListeDocumentsSelectionnesCascade(dossier: any): DocumentDto[] {
        let liste: DocumentDto[] = [];

        if (!dossier.isSelected && dossier.Documents != undefined && dossier.Documents.length > 0) {
            let documentsSelectionnes = dossier.Documents.filter(d => d.isSelected && d.Code != undefined)
            if (documentsSelectionnes != undefined)
                liste.push.apply(liste, documentsSelectionnes);
        }
        if (dossier.SousDossier != undefined && dossier.SousDossier.length > 0) {
            dossier.SousDossier.forEach((sousDossier: any) => {
                liste.push.apply(liste, this.getListeDocumentsSelectionnesCascade(sousDossier));
            });
        }

        return liste;
    }

    public toggleOpen(dossier: DossierGedViewModel): void {
        // On empêche la fermeture si le dossier est encore en chargement
        if (dossier.CheminLogique !== undefined && !dossier.isLoading) {

            dossier.isOpen = !dossier.isOpen;

            if (dossier.isOpen && !dossier.isLoading) {
                this.setLoadingDossier(dossier);
                this.loadDossierData(dossier);
            } else {
                // A la fermeture du dossier, on déselectionne ses enfants
                if (!dossier.isOpen) {
                    this.selectionnerCascade(dossier, false);
                }

                this.$forceUpdate();
            }
        }
    }

    /**
     * Lance le téléchargement d'une archive avec tous les documents présents dans une liste de dossiers sélectionnés
     * @param listeDossiersSelectionnes
     */
    private gererTelechargementDossiers(listeDossiersSelectionnes: string[]): void {
        const commandeDossiers: CommandeTelechargementArchive = {
            listeDossiers: listeDossiersSelectionnes,
            listeDocuments: []
        };
        this.telechargeArchiveDossiers(commandeDossiers);
    }

    /**
     * Lance le téléchargement d'une archive avec tous les documents sélectionnés, et ceux présents dans les dossiers sélectionnés
     * @param listeDocumentsSelectionnes
     * @param listeDossiersSelectionnes
     */
    private gererTelechargementDocumentsEtDossiers(listeDocumentsSelectionnes: DocumentDto[], listeDossiersSelectionnes: string[]): void {
        const elementsATelecharger: CommandeTelechargementArchive = {
            listeDocuments: this.getListeDocumentsInfos(listeDocumentsSelectionnes),
            listeDossiers: listeDossiersSelectionnes,
        };
        this.telechargeArchiveDossiers(elementsATelecharger);
    }

    /**
     * Lance le téléchargement d'une archive de documents ou d'un document unique
     * @param listeDocumentsSelectionnes
     */
    private gererTelechargementDocuments(listeDocumentsSelectionnes: DocumentDto[]): void {
        if (listeDocumentsSelectionnes.length > 1) {
            let liste: DocumentInfoDto[] = this.getListeDocumentsInfos(listeDocumentsSelectionnes);
            this.telechargerArchiveDocuments(liste);
        } else if (listeDocumentsSelectionnes.length === 1) {
            this.telechargerDocument(listeDocumentsSelectionnes[0]);
        }
    }

    /**
     * Cette fonction récupère au travers du Services Factory un objet Dto 'DocumentsArchiveDto'.
     * 
     * Cet objet contient une archive de documents au format string, qu'il faut ensuite convertir en blob.
     * La conversion en blob est appelée ici et non pas à la récupération des données dans le Services Factory puisque l'objet récupéré ne contient pas que l'archive.
     * 
     * Il contient en effet également l'ensemble des noms de documents ayant provoqué une erreur de récupération dans le backend.
     * @param {DocumentDto[]} documents
     */
    private telechargerArchiveDocuments(documents: DocumentInfoDto[]): void {
        NotificationServiceInstance.SendInformation("La récupération de l'archive a commencé.", 2);
        this.dataReady = false;
        ServicesFactoryInstance.GedService.getArchive(documents, (data: DocumentsArchiveDto) => {
            this.traiterArchive(data, documents);
            this.dataReady = true
        }, () => {
            NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération de l'archive.");
            this.dataReady = true
        });
    }

    /**
     * Permet de récupérer les documents de plusieurs dossiers dans une seule archive
     * @param elementsATelecharger
     */
    private telechargeArchiveDossiers(elementsATelecharger: CommandeTelechargementArchive) {
        NotificationServiceInstance.SendInformation("La récupération de l'archive a commencé.", 2);
        this.dataReady = false;

        ServicesFactoryInstance.GedService.getArchiveDossiers(elementsATelecharger, data => {
            this.traiterArchive(data);
            this.dataReady = true;
        }, () => {
            NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération de l'archive.");
            this.dataReady = true
        });
    }

    /**
     * Traite le téléchargement d'une archive récupérée
     * @param archiveRecuperee
     * @param documentsRecuperes
     * @returns
     */
    private traiterArchive(archiveRecuperee: DocumentsArchiveDto, documentsRecuperes?: DocumentInfoDto[]) {
        let archiveStr = archiveRecuperee.Archive;
        let erreurs = archiveRecuperee.Erreurs

        if (archiveStr === undefined) {
            NotificationServiceInstance.SendFailed("Erreur dans la récupération de l'archive.");
            this.dataReady = true;
            return;
        }

        // Gestion des erreurs par document
        if (erreurs !== undefined && erreurs.length > 0) {
            if (documentsRecuperes != undefined && documentsRecuperes.length === erreurs.length) {
                NotificationServiceInstance.SendFailed("Aucun document sélectionné n'a pu être récupéré. Il est possible qu'ils n'existent plus.");
                this.dataReady = true;
            } else {
                this.sendFusedErrorsWarning(erreurs);
            }
        }

        // Téléchargement de l'archive
        let archive: Blob = this.convertArchiveStrToBlob(archiveStr);

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(archive, "Documents");
        } else {
            const link = document.createElement("a");
            document.body.appendChild(link);
            link.href = window.URL.createObjectURL(archive);
            link.download = "Documents.zip";
            link.click();
        }
    }

    /**
     * Vide la prévisualisation
     */
    private resetCurrentData(): void {
        this.currentData = undefined;
        this.currentDataUrl = undefined;
        this.currentDocument = undefined;
        this.canPreview = false;
    }

    /**
     * Reset le nombre de dossier / document sélectionné
     */
    private resetNbElementsSelectionnes() {
        this.nombreDocumentsSelectionnes = 0;
        this.nombreDossiersSelectionnes = 0;
    }

    /**
     * Permet de retirer les éléments qui ont été supprimé de la liste
     * @param dossier
     */
    private retireElementsSupprimes(dossier: DossierGedViewModel): void {
        // Retire les documents
        if (dossier.Documents.length > 0) {
            dossier.Documents = dossier.Documents.filter(document => !document.isSelected);
        }

        // Retire les dossiers
        if (dossier.SousDossier.length > 0) {
            dossier.SousDossier = dossier.SousDossier.filter(document => !document.isSelected);
        }

        if (dossier.SousDossier.length > 0) {
            dossier.SousDossier.forEach(d => {
                this.retireElementsSupprimes(d);
            });
        }
    }

    /**
     * Charge le dossier choisi (récupère ses sous dossiers et ses documents)
     * @param dossier
     */
    private loadDossierData(dossier: DossierGedViewModel): void {
        // Récupération du contenu du dossier
        ServicesFactoryInstance.GedService.getDocumentsFromPath(dossier.CheminLogique!, data => {
            data = DocumentGedHelper.sortArborescence(data);

            // Map le dossier
            const dossierViewModel: DossierGedViewModel = DocumentGedHelper.mapDossierToViewModel(data);

            // Charge son contenu
            dossier.Documents = dossierViewModel.Documents;
            dossier.SousDossier = dossierViewModel.SousDossier;

            // Set la valeur dossierParent
            this.affecterParentCascade(dossier);

            if (dossier.isSelected) {
                this.selectionnerCascade(dossier, true);
            }

            dossier.isLoading = false;
            this.$forceUpdate();
        }, () => {
            dossier.isLoading = false;
            this.$forceUpdate();
        });
    }

    /**
     * Récupère la liste des dossiers sélectionnés 
     * @param dossier
     * @returns
     */
    private getListeDossiersSelectionnes(dossier: DossierGedViewModel): string[] {
        let listeDossiers: string[] = [];

        if (dossier.isSelected) {
            listeDossiers.push(dossier.CheminLogique!);
        } else if (dossier.SousDossier.length >= 1) {
            dossier.SousDossier.forEach(d => {
                const sousDossiersSelectionnes = this.getListeDossiersSelectionnes(d);
                listeDossiers = listeDossiers.concat(sousDossiersSelectionnes);
            });
        }

        return listeDossiers;
    }

    /**
     * Récupère la liste des documents sélectionnés pour la suppression
     * @param dossier
     * @returns
     */
    private getListeDocumentsASupprimer(dossier: DossierGedViewModel): string[] {
        let listeDocuments: string[] = [];

        // On évite d'ajouter les documents qui sont présents dans des dossiers sélectionnés
        // Le back se charge d'archiver les éléments présents dans un dossier archivé
        if (dossier.Documents.length >= 1 && !dossier.isSelected) {
            dossier.Documents.forEach(document => {
                if (document.isSelected && document.Code !== undefined) {
                    listeDocuments.push(document.Code);
                }
            });
        }

        if (dossier.SousDossier.length >= 1) {
            dossier.SousDossier.forEach(d => {
                const documentsASupprimer = this.getListeDocumentsASupprimer(d);
                listeDocuments = listeDocuments.concat(documentsASupprimer);
            });
        }

        return listeDocuments;
    }

    /**
     * Vide le dossier et affiche le skeleton
     * Si le dossier a mettre en chargement est le dossier racine, on affiche le loader sur la page
     * @param dossier
     */
    private setLoadingDossier(dossier: DossierGedViewModel): void {
        if (dossier.CheminLogique !== this.dossierRacine?.CheminLogique) {
            // Affichage du skeleton pendant le chargement.
            dossier.isLoading = true;
            dossier.isOpen = true;
            dossier.Documents = [];
            dossier.SousDossier = [];
            this.$forceUpdate();
        } else {
            this.dataReady = false;
        }
    }

    public estDossierVide(dossier: DossierGedDto): boolean {
        let estVide = true;
        if ((dossier.Documents != undefined && dossier.Documents.length > 0)
            || (dossier.SousDossier != undefined && dossier.SousDossier.length > 0)) {
            estVide = false;
        }

        return estVide;
    }
}



// WEBPACK FOOTER //
// ./src/components/ged/documents.ts